<template>
    <div>
        <v-data-table
            :footer-props="{
                        'items-per-page-options': rowsPerPageItems,
                        'items-per-page-text': $t('global.rows_per_page')
                    }"
            :headers="headers"
            :items="alerts"
            :loading="loading"
            :loading-text="$t('global.loading_text')"
            :no-data-text="$t('global.no_data')"
            :no-results-text="$t('global.no_results_text')"
            :options.sync="options"
            :server-items-length="number_of_alerts"
            @update:options="changeOptions"
        >
            <template v-slot:item.created_at="{ item }">
                {{ item.created_at | moment('L LT') }}
            </template>

            <template v-slot:item.driver="{ item }">
                {{ item.alertable && item.alertable.driver ? item.alertable.driver.name : '-' }}
            </template>

            <template v-slot:item.truck="{ item }">
                {{ item.alertable.truck.code }}
            </template>

            <template v-slot:item.site="{ item }">
                {{ item.alertable && item.alertable.site ? item.alertable.site.name : '-' }}
            </template>

            <template v-slot:item.silo="{ item }">
                {{ item.alertable.silo.code }}
            </template>

            <template v-slot:item.type="{ item }">
                {{ item.alertable.type }}
            </template>

            <template v-slot:item.access="{ item }">
                {{ getAccessName(item) }}
            </template>

            <template v-slot:item.equipment="{ item }">
                {{ getEquipmentName(item) }}
            </template>

            <template v-slot:item.actions="{ item }">
                <v-icon @click="goToSite(item)"
                    :title="$t('site.see_step_detail')"
                    class="mr-2"
                    small>
                    mdi-eye
                </v-icon>

                <v-btn
                    :loading="loading"
                    :title="$t('alert.manage')"
                    class="mr-2"
                    color="primary"
                    tile
                    x-small
                    @click="resolve(item)"
                >
                    <v-icon
                        :title="$t('alert.manage')"
                        class="mr-1"
                        small
                    >
                        mdi-hammer-screwdriver
                    </v-icon>
                    {{ $t('alert.manage') }}
                </v-btn>

                <v-icon
                    small
                    @click="openActionNotificationDialog(item)"
                    :title="$t('alert.action_notification')"
                >
                    mdi-file-plus
                </v-icon>
            </template>
        </v-data-table>

        <action-notification-dialog
            v-if="itemToResolve && itemToResolve.alertable"
            :show_dialog="action_notification_dialog"
            :alert="itemToResolve"
            action_type_code="maj_access_equipment_treated"
            @reload-alerts="getAccessEquipmentUpdateRequestAlerts"
            @close-dialog="closeActionNotificationDialog"
            @action-created-succeeded="actionCreatedSucceeded"
            @action-created-failed="actionCreatedFailed"
        />

        <v-dialog v-model="dialogResolve" :disabled="loading" max-width="290">
            <v-card elevation="0">
                <v-card-title class="headline">{{ $t('alert.resolve_alert') }}</v-card-title>
                <v-card-text>
                    <v-col>
                        <v-textarea
                            v-model="action_comment"
                            :disabled="loading"
                            :label="$t('alert.comment')"
                            name="input-7-4"
                            solo
                        ></v-textarea>
                    </v-col>
                </v-card-text>
                <v-card-actions>
                    <v-spacer/>
                    <v-btn :disabled="loading" color="darken-1" text @click="dialogResolve = false">
                        {{ $t('alert.cancel') }}
                    </v-btn>
                    <v-btn :disabled="loading" color="success darken-1" text @click="createAction()">
                        {{ $t('alert.resolve_alert') }}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-snackbar
            v-model="snackbar"
            :color="snackbar_type"
            top
        >
            {{ snackbar_text }}
            <v-btn
                text
                @click="snackbar = false"
            >
                Close
            </v-btn>
        </v-snackbar>
    </div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import {
    ACCESS_EQUIPMENT_UPDATE_REQUEST,
    ACTION_TYPE,
    ACTIONS,
    ALERT,
} from "../../api";
import ActionNotificationDialog from "../Actions/ActionNotificationDialog.vue";

export default {
    name: 'access-equipment-update-request-alert-datatable',
    components: {ActionNotificationDialog},
    data() {
        return {
            loading: false,
            headers: [
                {text: this.$t('alert.created_at'), value: 'created_at', sortable: false},
                {text: this.$t('alert.driver'), value: 'driver', sortable: false},
                {text: this.$t('alert.truck'), value: 'truck', sortable: false},
                {text: this.$t('alert.site'), value: 'site', sortable: false},
                {text: this.$t('alert.silo'), value: 'silo', sortable: false},
                {text: this.$t('alert.modification'), value: 'type', sortable: false},
                {text: this.$t('alert.access'), value: 'access', sortable: false},
                {text: this.$t('alert.equipment'), value: 'equipment', sortable: false},
                {text: this.$t('alert.actions'), value: 'actions', sortable: false},
                ],
                dialogResolve: false,
                itemToResolve: {},
                snackbar: false,
                snackbar_text: '',
                snackbar_type: null,
                maj_access_equipment_treated_action_type_id: null,
                action_comment: null,
                alerts: [],
                number_of_alerts: 0,
                options: {page: 1, itemsPerPage: 10},
                rowsPerPageItems: [5, 10, 100],
                action_notification_dialog: false,
            }
        },
        mounted() {
            this.getAccessEquipmentUpdateRequestAlerts();
            this.getMajAccessEquipmentActionType();
        },
        methods: {
            ...mapActions({count_alerts: 'alert/count'}),
            ...mapGetters({get_filters: 'alert/get_filters'}),
            actionCreatedSucceeded(){
                this.showSnackbar('success', this.$t('alert.action_created'));
            },
            actionCreatedFailed(){
                this.showSnackbar('error', this.$t('global.error'));
            },
            closeActionNotificationDialog(){
                this.action_notification_dialog = false;
                this.itemToResolve = null;
            },
            openActionNotificationDialog(item){
                this.action_notification_dialog = true;
                this.itemToResolve = item;
            },
            resetSnackbar() {
                this.snackbar_type = null;
                this.snackbar_text = null;
                this.snackbar = false;
            },
            showSnackbar(type, text) {
                this.snackbar_type = type;
                this.snackbar_text = text;
                this.snackbar = true;
            },
            updateAlert() {
                this.loading = true;
                this.axios.put(
                    this.replacePathParams(ALERT, {alert: this.itemToResolve.id}),
                    {
                        'is_treated' : 1,
                    }
                ).then(() => {
                    this.getAccessEquipmentUpdateRequestAlerts();
                    this.count_alerts();
                    this.showSnackbar('success', this.$t('alert.alert_closed'));
                }).catch((error) => {
                    if (error.response.status === 422) {
                        this.showSnackbar('warning', this.parseLaravelError(error));
                    } else {
                        this.showSnackbar('error', this.$t('global.error'));
                    }
                }).finally(() => {
                    this.loading = false;
                })
            },
            getAccessEquipmentUpdateRequestAlerts() {
                this.loading = true;
                this.axios.get(ACCESS_EQUIPMENT_UPDATE_REQUEST,
                    {params: {
                        page: this.options.page, per_page: this.options.itemsPerPage,
                        logistic_areas: this.get_filters().logistic_areas_choices
                    }}
                ).then((success) => {
                    this.alerts = success.data.data;
                    this.number_of_alerts = success.data.total;
                }).catch(() => {
                    this.showSnackbar('error', this.$t('global.error'));
                }).finally(() => {
                    this.loading = false;
                });
            },
            getMajAccessEquipmentActionType(){
                this.loading = true;
                this.axios.get(this.replacePathParams(ACTION_TYPE, {code: 'maj_access_equipment_treated'}),
                    {}
                ).then((success) => {
                    this.maj_access_equipment_treated_action_type_id = success.data.id;
                }).catch(() => {
                    this.showSnackbar('error', this.$t('global.error'));
                }).finally(() => {
                    this.loading = false;
                });
            },
            resolve(item) {
                this.dialogResolve = true;
                this.action_comment = null;
                this.itemToResolve = item;
            },
            goToSite(item) {
                let siteId = item.alertable.site.id;
                if(siteId){
                    let routeData = this.$router.resolve({name: 'site', params: {siteId}});
                    window.open(routeData.href, '_blank');
                }
            },
            async createAction() {
                this.loading = true;

                let action = {
                    site_id: this.itemToResolve.alertable.site.id ?? null,
                    silo_id: this.itemToResolve.alertable.silo.id ?? null,
                    type_id: this.maj_access_equipment_treated_action_type_id,
                    details: this.action_comment,
                };

                await this.axios.post(ACTIONS, action);
                this.updateAlert();
                this.loading = false;
                this.dialogResolve = false;
            },
            changeOptions(options) {
                this.options.itemsPerPage = options.itemsPerPage;
                this.options.page = options.page;
                this.getAccessEquipmentUpdateRequestAlerts();
            },
            getAccessName(item){
                return item.alertable?.access?.name ?? '-'
            },
            getEquipmentName(item){
                return item.alertable?.equipment?.name ?? '-'
            }
        },
    }
</script>
